/**
 * Shuffler Class
 * Shuffles direct child DOM elements within a specified container on page load.
 */
export class Shuffler {
  /**
   * Constructor
   * @param {Element} containerElement - The DOM element containing elements to shuffle
   */
  constructor(containerElement) {
    if (!(containerElement instanceof Element)) {
      throw new Error("Shuffler constructor requires a DOM element");
    }
    this.container = containerElement;
    this.init();
  }

  /**
   * Initialize the shuffler
   * Selects direct child elements and performs the shuffle
   */
  init() {
    this.elements = [...this.container.querySelectorAll(':scope > *')];
    this.shuffle();
  }

  /**
   * Shuffle the elements
   */
  shuffle() {
    for (let i = this.elements.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.elements[i], this.elements[j]] = [this.elements[j], this.elements[i]];
    }
    this.render();
  }

  /**
   * Render the shuffled elements
   */
  render() {
    const fragment = document.createDocumentFragment();
    this.elements.forEach(element => fragment.appendChild(element));
    this.container.appendChild(fragment);

    this.elements.forEach(element => {
      element.style.visibility = 'inherit';
    });
  }
}
